import React, { useState } from "react";
import {
  FaPlus,
  FaCog,
  FaBox,
  FaCoins,
  FaUniversity,
  FaBitcoin,
} from "react-icons/fa";
import AssetRegistrationModal from "./components/AssetRegistrationModal";

const AssetRegistration = () => {
  const [assetType, setAssetType] = useState("current");
  const [currentAssetSubType, setCurrentAssetSubType] = useState("cash");
  const [showModal, setShowModal] = useState(false);

  const handleAssetRegistered = () => {
    // You can add any additional logic here like refreshing lists, etc.
    console.log("Asset registered successfully");
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
          Asset Registration
        </h2>
        <p className="mt-3 text-lg text-slate-600 max-w-2xl mx-auto">
          Register new assets for your accounting system
        </p>
      </div>

      {/* Asset Type Selection */}
      <div className="bg-white/60 backdrop-blur-sm rounded-2xl border border-slate-200/60 shadow-lg p-8">
        <h3 className="text-2xl font-bold text-slate-800 mb-6">
          Select Asset Type
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <button
            className={`p-6 border-2 rounded-2xl transition-all duration-300 text-left ${
              assetType === "current"
                ? "border-blue-500 bg-gradient-to-br from-blue-50 to-blue-100/80 shadow-xl"
                : "border-slate-200 bg-white/80 hover:border-slate-300 hover:shadow-lg"
            }`}
            onClick={() => setAssetType("current")}
          >
            <div className="flex items-center space-x-4">
              <div
                className={`p-3 rounded-xl ${
                  assetType === "current"
                    ? "bg-gradient-to-br from-blue-500 to-blue-600"
                    : "bg-slate-100"
                }`}
              >
                <FaCoins
                  className={`w-6 h-6 ${
                    assetType === "current" ? "text-white" : "text-slate-400"
                  }`}
                />
              </div>
              <div>
                <h4
                  className={`text-lg font-bold ${
                    assetType === "current"
                      ? "text-slate-800"
                      : "text-slate-700"
                  }`}
                >
                  Current Assets
                </h4>
                <p
                  className={`text-sm ${
                    assetType === "current"
                      ? "text-slate-600"
                      : "text-slate-500"
                  }`}
                >
                  Cash, Bank, Crypto accounts
                </p>
              </div>
            </div>
          </button>

          <button
            className={`p-6 border-2 rounded-2xl transition-all duration-300 text-left ${
              assetType === "fixed"
                ? "border-purple-500 bg-gradient-to-br from-purple-50 to-purple-100/80 shadow-xl"
                : "border-slate-200 bg-white/80 hover:border-slate-300 hover:shadow-lg"
            }`}
            onClick={() => setAssetType("fixed")}
          >
            <div className="flex items-center space-x-4">
              <div
                className={`p-3 rounded-xl ${
                  assetType === "fixed"
                    ? "bg-gradient-to-br from-purple-500 to-purple-600"
                    : "bg-slate-100"
                }`}
              >
                <FaCog
                  className={`w-6 h-6 ${
                    assetType === "fixed" ? "text-white" : "text-slate-400"
                  }`}
                />
              </div>
              <div>
                <h4
                  className={`text-lg font-bold ${
                    assetType === "fixed" ? "text-slate-800" : "text-slate-700"
                  }`}
                >
                  Fixed Assets
                </h4>
                <p
                  className={`text-sm ${
                    assetType === "fixed" ? "text-slate-600" : "text-slate-500"
                  }`}
                >
                  Long-term tangible assets
                </p>
              </div>
            </div>
          </button>

          <button
            className={`p-6 border-2 rounded-2xl transition-all duration-300 text-left ${
              assetType === "trading"
                ? "border-emerald-500 bg-gradient-to-br from-emerald-50 to-emerald-100/80 shadow-xl"
                : "border-slate-200 bg-white/80 hover:border-slate-300 hover:shadow-lg"
            }`}
            onClick={() => setAssetType("trading")}
          >
            <div className="flex items-center space-x-4">
              <div
                className={`p-3 rounded-xl ${
                  assetType === "trading"
                    ? "bg-gradient-to-br from-emerald-500 to-emerald-600"
                    : "bg-slate-100"
                }`}
              >
                <FaBox
                  className={`w-6 h-6 ${
                    assetType === "trading" ? "text-white" : "text-slate-400"
                  }`}
                />
              </div>
              <div>
                <h4
                  className={`text-lg font-bold ${
                    assetType === "trading"
                      ? "text-slate-800"
                      : "text-slate-700"
                  }`}
                >
                  Trading Assets
                </h4>
                <p
                  className={`text-sm ${
                    assetType === "trading"
                      ? "text-slate-600"
                      : "text-slate-500"
                  }`}
                >
                  Inventory and trading goods
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>

      {/* Current Asset Sub-type Selection */}
      {assetType === "current" && (
        <div className="bg-white/60 backdrop-blur-sm rounded-2xl border border-slate-200/60 shadow-lg p-8">
          <h3 className="text-2xl font-bold text-slate-800 mb-6">
            Select Current Asset Type
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <button
              className={`p-6 border-2 rounded-2xl transition-all duration-300 text-left ${
                currentAssetSubType === "cash"
                  ? "border-green-500 bg-gradient-to-br from-green-50 to-green-100/80 shadow-xl"
                  : "border-slate-200 bg-white/80 hover:border-slate-300 hover:shadow-lg"
              }`}
              onClick={() => setCurrentAssetSubType("cash")}
            >
              <div className="flex items-center space-x-4">
                <div
                  className={`p-3 rounded-xl ${
                    currentAssetSubType === "cash"
                      ? "bg-gradient-to-br from-green-500 to-green-600"
                      : "bg-slate-100"
                  }`}
                >
                  <FaCoins
                    className={`w-6 h-6 ${
                      currentAssetSubType === "cash"
                        ? "text-white"
                        : "text-slate-400"
                    }`}
                  />
                </div>
                <div>
                  <h4
                    className={`text-lg font-bold ${
                      currentAssetSubType === "cash"
                        ? "text-slate-800"
                        : "text-slate-700"
                    }`}
                  >
                    Cash Account
                  </h4>
                  <p
                    className={`text-sm ${
                      currentAssetSubType === "cash"
                        ? "text-slate-600"
                        : "text-slate-500"
                    }`}
                  >
                    Physical cash holdings
                  </p>
                </div>
              </div>
            </button>

            <button
              className={`p-6 border-2 rounded-2xl transition-all duration-300 text-left ${
                currentAssetSubType === "bank"
                  ? "border-blue-500 bg-gradient-to-br from-blue-50 to-blue-100/80 shadow-xl"
                  : "border-slate-200 bg-white/80 hover:border-slate-300 hover:shadow-lg"
              }`}
              onClick={() => setCurrentAssetSubType("bank")}
            >
              <div className="flex items-center space-x-4">
                <div
                  className={`p-3 rounded-xl ${
                    currentAssetSubType === "bank"
                      ? "bg-gradient-to-br from-blue-500 to-blue-600"
                      : "bg-slate-100"
                  }`}
                >
                  <FaUniversity
                    className={`w-6 h-6 ${
                      currentAssetSubType === "bank"
                        ? "text-white"
                        : "text-slate-400"
                    }`}
                  />
                </div>
                <div>
                  <h4
                    className={`text-lg font-bold ${
                      currentAssetSubType === "bank"
                        ? "text-slate-800"
                        : "text-slate-700"
                    }`}
                  >
                    Bank Account
                  </h4>
                  <p
                    className={`text-sm ${
                      currentAssetSubType === "bank"
                        ? "text-slate-600"
                        : "text-slate-500"
                    }`}
                  >
                    Bank account details
                  </p>
                </div>
              </div>
            </button>

            <button
              className={`p-6 border-2 rounded-2xl transition-all duration-300 text-left ${
                currentAssetSubType === "crypto"
                  ? "border-orange-500 bg-gradient-to-br from-orange-50 to-orange-100/80 shadow-xl"
                  : "border-slate-200 bg-white/80 hover:border-slate-300 hover:shadow-lg"
              }`}
              onClick={() => setCurrentAssetSubType("crypto")}
            >
              <div className="flex items-center space-x-4">
                <div
                  className={`p-3 rounded-xl ${
                    currentAssetSubType === "crypto"
                      ? "bg-gradient-to-br from-orange-500 to-orange-600"
                      : "bg-slate-100"
                  }`}
                >
                  <FaBitcoin
                    className={`w-6 h-6 ${
                      currentAssetSubType === "crypto"
                        ? "text-white"
                        : "text-slate-400"
                    }`}
                  />
                </div>
                <div>
                  <h4
                    className={`text-lg font-bold ${
                      currentAssetSubType === "crypto"
                        ? "text-slate-800"
                        : "text-slate-700"
                    }`}
                  >
                    Crypto Account
                  </h4>
                  <p
                    className={`text-sm ${
                      currentAssetSubType === "crypto"
                        ? "text-slate-600"
                        : "text-slate-500"
                    }`}
                  >
                    Cryptocurrency holdings
                  </p>
                </div>
              </div>
            </button>
          </div>
        </div>
      )}

      {/* Registration Form */}
      <div className="bg-white/60 backdrop-blur-sm rounded-2xl border border-slate-200/60 shadow-lg p-8">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-2xl font-bold text-slate-800">
            Register{" "}
            {assetType === "current"
              ? `${
                  currentAssetSubType.charAt(0).toUpperCase() +
                  currentAssetSubType.slice(1)
                } `
              : ""}
            {assetType.charAt(0).toUpperCase() + assetType.slice(1)} Asset
          </h3>
          <button
            onClick={() => setShowModal(true)}
            className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 font-semibold shadow-lg shadow-blue-500/25 transition-all duration-200"
          >
            <FaPlus className="w-4 h-4" />
            <span>Register Asset</span>
          </button>
        </div>
      </div>

      {/* Registration Modal */}
      <AssetRegistrationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        assetType={assetType}
        currentAssetSubType={currentAssetSubType}
        onRegister={handleAssetRegistered}
      />
    </div>
  );
};

export default AssetRegistration;
